import Image from 'next/image';
import Link from 'next-intl/link';
import { MdLocationOn } from 'react-icons/md';
import AuctionTimer from './AuctionTimer';
import useLocaleSuffix from '../utils/useLocaleSuffix';
import PriceTag from './Card/PriceTag';
import { useLocaleRoutes } from '../utils/useLocaleRoutes';
import { useTranslations } from 'next-intl';
import { RootState } from '../redux/store';
import { useSelector } from 'react-redux';
import useFormatterPrice from '@/src/utils/formatter-price';
const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE;

export default function Card({ item = {} }: { item: any }) {
  const path = useLocaleRoutes();
  const getLocaleSuffix = useLocaleSuffix();
  const t = useTranslations('page.category');
  const formatterPrice = useFormatterPrice();

  const auctionEndDate: number = useSelector((state: RootState) => {
    if (!item || !item.hasOwnProperty('ad_auction') || !item.ad_auction)
      return false;
    const auction = state.auctions[item.ad_auction.id];
    return auction
      ? auction.time_end_extended
      : item.ad_auction.time_end_extended;
  });

  let imgUrl =
    item.ad_images && item.ad_images.length
      ? item.ad_images[0]?.url_thumbnail
      : item.ad_images[0]?.url_thumbnail
        ? item.ad_images[0]?.url_medium
        : false;

  return (
    <Link href={`/${path('item')}/${item.id}`} className='flex h-full'>
      <article className='card group relative flex h-full w-full flex-col overflow-hidden rounded-lg bg-black font-roboto-condensed'>
        <div className='flex items-center justify-between bg-green px-2 py-1 text-sm font-semibold leading-tight text-white/70 md:text-base'>
          # {item.id}
          {item.ad_auction && (
            <p className='text-xs uppercase text-brand md:text-sm'>
              {item.ad_auction.amount_min > 0 ? '' : t('noMinimumPrice')}
            </p>
          )}
        </div>
        <PriceTag ad={item} />
        <div className='relative flex items-center justify-center overflow-hidden pt-[75%]'>
          {item?.ad_auction?.status === 4 && (
            <div className='absolute bottom-6 left-0 z-20 rounded-r bg-brand-alt px-4 py-1 font-bold'>
              {t('sold')}
            </div>
          )}
          <img
            src={imgUrl}
            alt=''
            width={0}
            height={0}
            style={{
              width: '100%',
              height: '100%',
              overflow: 'hidden',
              objectFit: 'cover',
            }}
            className='absolute inset-0 opacity-60 blur'
          />
          <img
            src={imgUrl}
            alt={item[getLocaleSuffix('title')]}
            width={0}
            height={0}
            sizes='100vw'
            style={{
              width: '100%',
              height: '100%',
              overflow: 'hidden',
              objectFit: 'contain',
            }}
            className='absolute inset-0 transition duration-700 group-hover:scale-105'
          />
          <div className='absolute bottom-0 h-12 w-full bg-gradient-to-t from-black to-black/0'></div>
        </div>
        <div className='z-10 -mt-8 flex w-full flex-grow flex-col justify-between p-4 pb-2 pt-8 text-white'>
          <h2 className='text-ll mb-2 flex-grow font-semibold leading-tight transition-all'>
            {item[getLocaleSuffix('title')]}
          </h2>
          <div className='flex items-center justify-between border-t-[1px] border-white pt-2 text-sm leading-tight'>
            <span>{item.year}</span>
            {item.municipality && (
              <span className='flex items-center gap-1'>
                <MdLocationOn /> {item.municipality}
              </span>
            )}
          </div>
          {auctionEndDate && <AuctionTimer end={auctionEndDate} />}
        </div>
      </article>
    </Link>
  );
}
